import { render, staticRenderFns } from "./SmCardOwnerNotification.vue?vue&type=template&id=b3682338&"
import script from "./SmCardOwnerNotification.vue?vue&type=script&lang=ts&"
export * from "./SmCardOwnerNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports